import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCJezabel extends NPC {
    constructor() {
        super(definitions.NPC_ID.JEZABEL);

        this.collisionRadius = 25;
        this.collisionOffsetX = 10;
        this.collisionOffsetY = -26;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_jezabel_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 1, new PIXI.Point(12, -6));
        this.animateIdle(0.5);
    }

    onViewAdded() {
        super.onViewAdded();

        this._status.y += 12;
    }
}